import React from "react";
import { NavLink } from "react-router-dom";

const Sidebar = ({ sidebarOpen }) => {
  return (
    <aside className={`sidebar ${sidebarOpen ? "open" : ""}`}>
      <div className="brand">₹xpense</div>
      <nav className="nav">
        <NavLink end to="/" className="nav-link">
          <span className="icon">🏠</span> Dashboard
        </NavLink>
        <NavLink to="/add" className="nav-link">
          <span className="icon">➕</span> Add Transaction
        </NavLink>
        {/* New Saved Cards link */}
        <NavLink to="/saved-cards" className="nav-link">
          <span className="icon">💳</span> Saved Cards
        </NavLink>
      </nav>
      <div className="sidebar-footer">v1.0</div>
    </aside>
  );
};

export default Sidebar;
